import { render, staticRenderFns } from "./AccountApp.vue?vue&type=template&id=66147b5c&scoped=true&"
import script from "./AccountApp.vue?vue&type=script&lang=js&"
export * from "./AccountApp.vue?vue&type=script&lang=js&"
import style0 from "./AccountApp.vue?vue&type=style&index=0&id=66147b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66147b5c",
  null
  
)

export default component.exports